import React from "react";
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import { useFeatureFlag } from "../contexts/FeatureFlagProvider";

export default function RouteGuard({
  flag,
  children,
  redirectTo = "/loja/notFound/",
  replace = true,
}) {
  const enabled = useFeatureFlag(flag);
  const location = useLocation();

  if (enabled) return <>{children}</>;

  return (
    <Navigate
      to={redirectTo}
      replace={replace}
      state={{ from: location.pathname, blockedByFlag: flag }}
    />
  );
}

RouteGuard.propTypes = {
  flag: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  redirectTo: PropTypes.string,
  replace: PropTypes.bool,
};

